import { render } from "./ListaModelos.vue?vue&type=template&id=0d7fbe5c&scoped=true&ts=true"
import script from "./ListaModelos.vue?vue&type=script&lang=ts"
export * from "./ListaModelos.vue?vue&type=script&lang=ts"

import "./ListaModelos.vue?vue&type=style&index=0&id=0d7fbe5c&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d7fbe5c"]])

export default __exports__